<template>
  <div>
    Ichimoku: {{ rule.config.term }} Tenkan-sen days, {{ rule.config.term2 }} Kijunn-sen days,
    {{ rule.config.term3 }} Senkou span days.
    {{ LookupTarget(rule.config.target) }}
    {{ LookupAction(rule.config.action) }}
    {{ LookupTarget(rule.config.comparison) }}
    <span v-if="rule.config.action == 5 || rule.config.action == 6"
      >for past {{ rule.config.days }} days</span
    >
  </div>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  data() {
    return {
      actions: [
        { id: 1, description: 'Crossed Above' },
        { id: 2, description: 'Crossed Below' },
        { id: 3, description: 'Is Above' },
        { id: 4, description: 'Is Below' },
        { id: 5, description: 'Trending Up' },
        { id: 6, description: 'Trending Down' },
        { id: 7, description: 'Up Relative to' },
        { id: 8, description: 'Down Relative to' }
      ],
      mappings: [
        { id: 1, description: 'Closing Price' },
        { id: 2, description: 'Tenkan' },
        { id: 3, description: 'Kijun' },
        { id: 4, description: 'Chikou' },
        { id: 5, description: 'Senkou Span A' },
        { id: 6, description: 'Senkou Span B' }
      ]
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  created() {},

  methods: {
    LookupAction(id) {
      var desc = ''
      for (var i = 0; i < this.actions.length; i++) {
        var a = this.actions[i]
        if (a.id == id) {
          desc = a.description
          break
        }
      }
      return desc
    },
    LookupTarget(id) {
      var desc = ''
      for (var i = 0; i < this.mappings.length; i++) {
        var a = this.mappings[i]
        if (a.id == id) {
          desc = a.description
          break
        }
      }
      return desc
    }
  }
}
</script>
